import React, {useEffect} from "react";
import styles from "./processMap/mainContent/MainContent.module.scss";
import Graph from "./processMap/Graph";

const ProcessExplorer = props => {
    useEffect(()=>{
        if(props.location.state)
        {
            localStorage.setItem('uid',props.location.state.uid)
            localStorage.setItem('name',props.location.state.name)
        }
    },[])
  return (
        <div className={`container-fluid p-24`}>
            <div className={`row ${styles.MainContent}`}>
                <Graph type="processExplorer" processExplorer/>
            </div>
        </div>
  )
};

export default ProcessExplorer;
